import React from 'react';

const PageHeader: React.FC = () => {
  const annotatorBased = <div className="text-small">All Identifiers &gt; New Identifier</div>;

  const renderPageHeader = (): JSX.Element => annotatorBased;

  return (
    <div>
      <nav className="hidden sm:flex items-center text-small">{renderPageHeader()}</nav>
    </div>
  );
};

export default PageHeader;
